import { useEffect } from 'react';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { ProductSearch as FormProductSearch } from '../../widgets';
import { QuestionPayload } from '../../schema';
import { CommentStatus, SearchProduct } from '../../types';
import _ from 'lodash';
import { useImmer } from 'use-immer';

const FormQuestion = ({
  disabledFields,
}: {
  disabledFields?: { [key: string]: string };
}): JSX.Element => {
  const {
    register,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext<QuestionPayload>();

  const [productSearch, setProductSearch] = useImmer<{
    show: boolean;
    item: SearchProduct;
  }>({
    show: false,
    item: {
      title: '',
      product_id: '',
      handle: '',
    },
  });
  useEffect(() => {
    if (productSearch.item.product_id.length > 0) {
      setValue('target_id', productSearch.item.product_id);
      trigger('target_id');
    }
  }, [productSearch.item.product_id]);
  return (
    <>
      <div className="space-y-4 mt-4">
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Tên người đặt câu hỏi
            <span className="text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            {...register('name')}
            className={clsx(
              errors.name
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
          />
          {errors.name ? (
            <p className="text-xs text-red-600">{errors.name.message}</p>
          ) : null}
        </div>
        <div className="flex space-x-4">
          <div className="space-y-1 flex flex-col flex-1">
            <label className="block text-sm font-medium text-gray-700">
              Email
              <span className="text-red-600 ml-1">*</span>
            </label>
            <input
              type="text"
              {...register('email')}
              className={clsx(
                errors.email
                  ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                  : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
                'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
              )}
            />
            {errors.email ? (
              <p className="text-xs text-red-600">{errors.email.message}</p>
            ) : null}
          </div>
          <div className="space-y-1 flex flex-col flex-1">
            <label className="block text-sm font-medium text-gray-700">
              Số điện thoại
            </label>
            <input
              type="text"
              {...register('phone')}
              className={clsx(
                errors.phone
                  ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                  : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
                'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
              )}
            />
            {errors.phone ? (
              <p className="text-xs text-red-600">{errors.phone.message}</p>
            ) : null}
          </div>
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Chọn sản phẩm
            <span className="text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            className={clsx(
              errors.target_id
                ? 'border-red-300 text-red-600 placeholder-red-500 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              !_.isUndefined(disabledFields) &&
                !_.isUndefined(disabledFields['target_id'])
                ? 'pointer-events-none bg-gray-100'
                : null,
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm cursor-pointer',
            )}
            placeholder="Click để chọn sản phẩm"
            readOnly
            value={
              !_.isUndefined(disabledFields) &&
              !_.isUndefined(disabledFields['target_id'])
                ? _.toString(disabledFields['target_id'])
                : productSearch.item.title
            }
            onClick={event => {
              event.preventDefault();
              setProductSearch(draft => {
                draft.show = true;
              });
            }}
          />
          {errors.target_id ? (
            <p className="text-xs text-red-600">{errors.target_id.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Mô tả
            <span className="text-red-600 ml-1">*</span>
          </label>
          <textarea
            {...register('desc')}
            className={clsx(
              errors.desc
                ? 'border-red-300 text-red-600 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 placeholder-gray-400 focus:ring-indigo-500 focus:border-indigo-500',
              'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
            )}
            rows={3}
          ></textarea>
          {errors.desc ? (
            <p className="text-xs text-red-600">{errors.desc.message}</p>
          ) : null}
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Trạng thái
          </label>
          <div className="flex justify-between">
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-active"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.active}
                {...register('status')}
              />
              <label
                htmlFor="status-active"
                className="block text-sm font-normal text-gray-700"
              >
                Hiển thị
              </label>
            </div>
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-pending"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.pending}
                {...register('status')}
              />
              <label
                htmlFor="status-pending"
                className="block text-sm font-normal text-gray-700"
              >
                Chờ duyệt
              </label>
            </div>
            <div className="flex items-center justify-center space-x-1">
              <input
                id="status-inactive"
                type="radio"
                className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                value={CommentStatus.inactive}
                {...register('status')}
              />
              <label
                htmlFor="status-inactive"
                className="block text-sm font-normal text-gray-700"
              >
                Tạm ẩn
              </label>
            </div>
          </div>
        </div>
      </div>
      <FormProductSearch show={productSearch.show} action={setProductSearch} />
    </>
  );
};
export default FormQuestion;
